import { CreateAccountAddressInput } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createAddressMutationAtom = createMutationAtomFactory(
  'crm.addressCreate',
  (input: CreateAccountAddressInput) => ({
    crmAccountAddressCreate: {
      __args: {
        input,
      },
      id: true,
    },
  }),
);
